module.exports = __webpack_public_path__ + "static/img/htjs4.feeffc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/htjs4.png
// module id = M4bm
// module chunks = 1